<template>
  <div>
    <div class="d-flex flex-column justify-space-between align-center">
      <v-img aspect-ratio="1" width="100%" max-width="200px" contain src="@/assets/Hand.svg"></v-img>
      <h1 class="display-1 font-weight-bold ma-5 white--text">A little bit about you...</h1>
    </div>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
    >
      <v-text-field
          outlined
          color="primary"
          v-model="surname"
          label="Name"
          :rules="[v => !!v || 'You must enter your name!']"
      ></v-text-field>

      <v-text-field
          outlined

          v-model="email"
          label="Email"
          :rules="emailRules"
      ></v-text-field>

<!--      <v-select-->
<!--          outlined-->
<!--          :items="genders"-->
<!--          v-model="gender"-->
<!--          label="Gender"-->
<!--          :rules="[v => !!v || 'You must select one!']"-->
<!--      ></v-select>-->

<!--      <v-text-field-->
<!--          outlined-->
<!--          v-model="func"-->
<!--          label="Function (Optional)"-->
<!--          color="primary"-->
<!--      ></v-text-field>-->

      <v-autocomplete
          color="primary"
          outlined
          :items="countries"
          item-value="text"
          v-model="country"
          label="Country"
          :rules="[v => !!v || 'You must select one!']"
      ></v-autocomplete>


      <v-checkbox
          color="primary"
          v-model="confirmAge"
          :rules="[v => !!v || 'You must agree to continue!']"
          label=""
          required
      >
        <template v-slot:label>
          <div>
            I confirm that I am older than 14 years old. By saving this Video, I agree, that my Data and my Video are saved for the purpose of the 1<sup>st</sup> Assembly of Women, Faith & Diplomacy. My Video and Data can be used to produce a visual summary of the Assembly and to promote the work of <span class="font-italic">Religions for Peace</span> and <span class="font-italic">Ring for Peace</span>.
          </div>
        </template>
      </v-checkbox>

      <v-checkbox
          color="primary"
          v-model="confirmPrivacy"
          :rules="[v => !!v || 'You must agree to continue!']"
          label="I have read the Data Protection Policy and agree."
          required
      >
        <template v-slot:label>
          <div>
            I have read the
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                                <span
                                    class="text-decoration-underline font-weight-bold"
                                    v-on="on"
                                >
                                  <dialog-modal
                                      title="Privacy"
                                      btn-ok=""
                                      btn-cancel="Close"
                                      btn-cancel-icon=""
                                      btn-ok-icon=""
                                      :body="privacy"
                                      max-width="80%"
                                  >
                                    Data Protection Policy</dialog-modal>
                                </span>


              </template>
              show Data Protection Policy
            </v-tooltip>
            and agree.
          </div>
        </template>

      </v-checkbox>


    </v-form>

    <stepper-footer @cancel="$emit('cancel')" @finished="validate"/>
  </div>
</template>

<script>
// @ is an alias to /src
// import { mapState } from 'vuex';
import StepperFooter from "../components/StepperFooter";
import countries from "@/helpers/countries";
import DialogModal from "@/components/DialogModal";
import strings from "@/lang/strings.json"

export default {
  name: 'StepRegister',
  components: {
    StepperFooter,
    DialogModal
  },
  data: () => ({
    privacy: strings.privacy,
    valid:false,
    genders: ['Female', 'Male'],
    countries: countries,
    emailRules: [
      v => !!v || "Email is required",
      v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Email is not valid'
    ],
  }),
  // ...
  computed: {
    surname: {
      get () {
        return this.$store.state.form.surname
      },
      set (value) {
        this.$store.commit('updateForm', {surname: value})
      }
    },
    email: {
      get () {
        return this.$store.state.form.email
      },
      set (value) {
        this.$store.commit('updateForm', {email: value})
      }
    },
    gender: {
      get () {
        return this.$store.state.form.gender
      },
      set (value) {
        this.$store.commit('updateForm', {gender: value})
      }
    },
    func: {
      get () {
        return this.$store.state.form.func
      },
      set (value) {
        this.$store.commit('updateForm', {func: value})
      }
    },
    country: {
      get () {
        return this.$store.state.form.country
      },
      set (value) {
        this.$store.commit('updateForm', {country: value})
      }
    },
    confirmAge: {
      get () {
        return this.$store.state.form.confirmAge
      },
      set (value) {
        this.$store.commit('updateForm', {confirmAge: value})
      }
    },
    confirmPrivacy: {
      get () {
        return this.$store.state.form.confirmPrivacy
      },
      set (value) {
        this.$store.commit('updateForm', {confirmPrivacy: value})
      }
    }
  },
  methods: {

    validate() {

      if(this.$refs.form.validate()) {

        // const frm = {
        //   surname: this.surname,
        //   email: this.email,
        //   gender: this.gender,
        //   func: this.func,
        //   confirmPrivacy: this.confirmPrivacy,
        //   confirmAge: this.confirmAge,
        // }
        //
        // this.$store.commit('setForm', frm);

        this.$emit('finished');
      }
    }

  }
}
</script>

<style lang="scss">
//.theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
//  color: blue;
//}

//.v-text-field fieldset, .v-text-field .v-input__control {
//  color: blue;
//}
//
//.theme--dark.v-input input, .theme--dark.v-input textarea {
//  color: blue;
//}

.v-select__selection--comma {
  color: #3f296c !important;
}

.v-text-field>.v-input__control>.v-input__slot:before {
  border-color:#3f296c !important;
}

.v-label {
  color: #3f296c !important;
}

.v-input:not(.v-input--is-disabled) input,
.v-input:not(.v-input--is-disabled) textarea {
  color: #3f296c !important;
}

.v-input--selection-controls__input .v-icon {
  color: #3f296c;
}

.error--text {
  color: #ffffff !important;
}


</style>
